import Vue from 'vue'
import Router from 'vue-router'
import home from '@/project/home/home'
import firstPage from '../project/home/firstPage'
import {Toast} from 'mint-ui'
/* const wsbxSb = () => import('@/project/ywbl/wsbx_sb')
import wsbxXz from '@/project/ywbl/wsbx_xz' */
import wsbxSb from '@/project/ywbl/wsbx_sb'
import wsbxSbmz from '@/project/ywbl/wsbx_sb_mz'
import wsbxSbzy from '@/project/ywbl/wsbx_sb_zy'
import wsbxSbgjzh from '@/project/ywbl/wsbx_sb_gjzh'
import wsbxcxSb from '@/project/ywbl/wsbx_sbcx'
import wsbxcxSbmz from '@/project/ywbl/wsbx_sbcx_mz'
import wsbxcxSbzy from '@/project/ywbl/wsbx_sbcx_zy'
import wsbxcxSbgjzh from '@/project/ywbl/wsbx_sbcx_gjzh'
const wsbxXz = () => import('@/project/ywbl/wsbx_xz')
const wsbxXz1 = () => import('@/project/ywbl/wsbx_xz1')
const wsbxXz2 = () => import('@/project/ywbl/wsbx_xz2')
const wsbxXz3 = () => import('@/project/ywbl/wsbx_xz3')
const grjbxxcx = () => import('@/project/grjbxxcx/grjbxxcx')
const jfxxcx = () => import('@/project/jfxxcx/jfxxcx')
const grbxxxcx = () => import('@/project/grbxxxcx/grbxxxcx')
const grjzxxDetail = () => import('@/project/grbxxxcx/grjzxxDetail')
const ydbaxxcx = () => import('@/project/ydbaxxcx/ydbaxxcx')
const tsbbacx = () => import('@/project/tsbbacx/tsbbacx')
const mxbbacx = () => import('@/project/mxbbacx/mxbbacx')
const gjtpy = () => import('@/project/gjtpy/gjtpy')
const gjtpyp = () => import('@/project/gjtpy/gjtpyp')
const gzypcx = () => import('@/project/gzypcx/gzypcx')
const gzypxxcx = () => import('@/project/gzypcx/gzypxxcx')
const grzhcx = () => import('@/project/grzhcx/grzhcx')
const ddjgcx = () => import('@/project/ddjgcx/ddjgcx')
const ddydcx = () => import('@/project/ddydcx/ddydcx')
const gjtpypddcx = () => import('@/project/gjtpypddcx/gjtpypddcx')
const ybml = () => import('@/project/ybml/ybml')
const grszmxcx = () => import('@/project/grszmxcx/grszmxcx')
const wsbx = () => import('@/project/ywbl/wsbx_nav')
const wsbxCx = () => import('@/project/ywbl/wsbx_cx')
const ydba = () => import('@/project/ywbl/ydba_nav')
const ydbaSb = () => import('@/project/ywbl/ydba_sb')
const ydbaCx = () => import('@/project/ywbl/ydba_cx')
const zjzf = () => import('@/project/ywbl/zjzf')
const gjryxxwh = () => import('@/project/ywbl/gjryxxwh')
const gjryXz = () => import('@/project/ywbl/gjry_xz')
const my = () => import('@/project/mine/my')
const login = () => import('@/project/mine/login')
const register = () => import('@/project/mine/register')
const unbind = () => import('@/project/mine/unbind')
const chpass = () => import('@/project/mine/changePass')
const chmobile = () => import('@/project/mine/changeMobile')
const ywbl = () => import('@/project/home/ywbl')
const datePicker = () => import('../../static/js/datePicker')
const queryService = () => import('../project/home/queryService')
const dzybk = () => import('../project/ywbl/dzybk')
const passkbd = () => import('../components/common/passkeyboard')
const orderlist = () => import('@/project/ywbl/orderList')
const payorderlist = () => import('@/project/ywbl/payedList')
const orderdetail = () => import('@/project/ywbl/orderDetail')
const navjzlist = () => import('@/project/ywbl/navJzList')
const myOrder = () => import('@/project/mine/myOrder')
const resetPass = () => import('@/project/mine/resetPass')
const ddyyAndYd = () => import('@/project/ddjgcx/ddyyAndYd')
const grzhTotal = () => import('@/project/grzhcx/grzhTotal')
const refresh = () => import('@/project/home/refresh')
const gjtpybaSb = () => import('@/project/ywbl/gjtpyba_sb')
const gjtpybaNav = () => import('@/project/ywbl/gjtpyba_nav')
const gjtpybaCx = () => import('@/project/ywbl/gjtpyba_cx')
const gjtpybaXz = () => import('@/project/ywbl/gjtpyba_xz')
const sysmfwNav = () => import('@/project/ywbl/sysmfw_nav')
const sysmfwXz = () => import('@/project/ywbl/sysmfw_xz')
const sysmfwPj = () => import('@/project/ywbl/sysmfw_pj')

const ydjycqbaNav = () => import('@/project/ywbl/ydjycqba_nav')
const ydjycqbaSb = () => import('@/project/ywbl/ydjycqba_sb')
const ydjycqbaCx = () => import('@/project/ywbl/ydjycqba_cx')

const ydjycqbasbCx = () => import('@/project/ywbl/ydjycqba_sbCx')

const ydjycqbaXz = () => import('@/project/ywbl/ydjycqba_xz')

// eslint-disable-next-line camelcase
const ydba_nav_flow1 = () => import('@/project/ywbl/ydba_nav_flow1')
// eslint-disable-next-line camelcase
const ydba_nav_flow2 = () => import('@/project/ywbl/ydba_nav_flow2')

const ydba_nav_flow3 = () => import('@/project/ywbl/ydba_nav_flow3')

// eslint-disable-next-line camelcase
const ydba_nav_mz = () => import('@/project/ywbl/ydba_mz')

// eslint-disable-next-line camelcase
const yyckbx_nav = () => import('@/project/ywbl/yyckbx_nav')

// eslint-disable-next-line camelcase
const yyckbx_xz = () => import('@/project/ywbl/yyckbx_xz')

const gyryEdit = () => import('@/project/ywbl/gyry_edit')

const mxbsq = () => import('@/project/ywbl/mxbsq')

const tsbsq = () => import('@/project/ywbl/tsbsq')

const txbtsbbaCx = () => import('@/project/ywbl/mxbtsbba_cx')

const lsbacx = () => import('@/project/ywbl/lsbacx')

const mbtbba = () => import('@/project/ywbl/mbtbba')

Vue.use(datePicker)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '首页',
      component: home,
      redirect: 'first',
      children: [
        {
          path: 'first',
          name: '首页',
          component: firstPage
        },
        {
          path: 'query',
          name: '查询服务',
          component: queryService
        },
        {
          path: 'ywbl',
          name: '业务办理',
          component: ywbl
        },
        {
          path: 'my',
          name: '我的',
          component: my
        }
      ]
    },
    {
      path: '/first',
      name: '首页',
      component: firstPage
    },
    {
      path: '/query',
      name: '查询服务',
      component: queryService
    },
    {
      path: '/ywbl',
      name: '业务办理',
      component: ywbl
    },
    {
      path: '/my',
      name: '我的',
      component: my
    },
    {
      path: '/jfxxcx',
      name: '缴费信息查询',
      component: jfxxcx
    },
    {
      path: '/grjbxxcx',
      name: '基本信息查询',
      component: grjbxxcx
    },
    {
      path: '/grbxxxcx',
      name: '个人就诊信息查询',
      component: grbxxxcx,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/grjzxxDetail/:akc190',
      name: '个人就诊明细查询',
      component: grjzxxDetail
    },
    {
      path: '/ydbaxxcx',
      name: '异地备案信息查询',
      component: ydbaxxcx
    },
    {
      path: '/tsbbacx',
      name: '特殊病备案查询',
      component: tsbbacx
    },
    {
      path: '/mxbbacx',
      name: '慢性病备案查询',
      component: mxbbacx
    },
    {
      path: '/gjtpy',
      name: '国家谈判药品备案查询',
      component: gjtpy
    },
    {
      path: '/gjtpyp',
      name: '国家谈判药品信息查询',
      component: gjtpyp
    },
    {
      path: '/gzypcx',
      name: '高值药品备案查询',
      component: gzypcx
    },
    {
      path: '/gzypxxcx',
      name: '高值药品信息查询',
      component: gzypxxcx
    },
    {
      path: '/grzhcx',
      name: '个人账户查询',
      component: grzhcx
    },
    {
      path: '/ddjgcx',
      name: '定点医院查询',
      component: ddjgcx,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/ddydcx',
      name: '定点药店查询',
      component: ddydcx,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/gjtpypddcx',
      name: '国家谈判药品定点查询',
      component: gjtpypddcx,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/ybml',
      name: '国家药品目录',
      component: ybml
    },
    {
      path: '/grszmxcx',
      name: '个人收支明细查询',
      component: grszmxcx
    },
    {
      path: '/wsbx',
      name: '网上报销',
      component: wsbx
    },
    {
      path: '/wsbxXz',
      name: '个人账户报销须知',
      component: wsbxXz
    },
    {
      path: '/wsbxXz1',
      name: '门诊报销须知',
      component: wsbxXz1
    },
    {
      path: '/wsbxXz2',
      name: '住院报销须知',
      component: wsbxXz2
    },
    {
      path: '/wsbxXz3',
      name: '家庭成员医疗费用报销须知',
      component: wsbxXz3
    },
    {
      path: '/wsbxSb',
      name: '个人账户报销申报',
      component: wsbxSb
      /* meta: {
        keepAlive: true
      } */
    },
    {
      path: '/wsbxSbmz',
      name: '门诊统筹报销申报',
      component: wsbxSbmz
      /* meta: {
        keepAlive: true
      } */
    },
    {
      path: '/wsbxSbzy',
      name: '住院报销申报',
      component: wsbxSbzy
      /* meta: {
        keepAlive: true
      } */
    },
    {
      path: '/wsbxSbgjzh',
      name: '家庭成员医疗费用报销',
      component: wsbxSbgjzh
      /* meta: {
        keepAlive: true
      } */
    },
    {
      path: '/wsbxcxSb',
      name: '个人账户报销申报查询',
      component: wsbxcxSb
      /* meta: {
        keepAlive: true
      } */
    },
    {
      path: '/wsbxcxSbmz',
      name: '门诊统筹报销申报查询',
      component: wsbxcxSbmz
      /* meta: {
        keepAlive: true
      } */
    },
    {
      path: '/wsbxcxSbzy',
      name: '住院报销申报查询',
      component: wsbxcxSbzy
      /* meta: {
        keepAlive: true
      } */
    },
    {
      path: '/wsbxcxSbgjzh',
      name: '家庭成员医疗费用报销查询',
      component: wsbxcxSbgjzh
      /* meta: {
        keepAlive: true
      } */
    },
    {
      path: '/wsbxCx',
      name: '网上报销查询',
      component: wsbxCx
    },
    {
      path: '/ydba',
      name: '异地备案',
      component: ydba
    },
    {
      path: '/ydbaSb',
      name: '异地住院备案申报',
      component: ydbaSb
    },
    {
      path: '/ydbaCx',
      name: '异地住院备案查询',
      component: ydbaCx
    },
    {
      path: '/zjzf',
      name: '医院列表',
      component: zjzf
    },
    {
      path: '/gjryXz',
      name: '家庭成员信息变更承诺书',
      component: gjryXz
    },
    {
      path: '/gjryxxwh',
      name: '家庭成员信息变更',
      component: gjryxxwh
    },
    {
      path: '/login',
      name: '登录',
      component: login
    },
    {
      path: '/register',
      name: '注册',
      component: register
    },
    {
      path: '/unbind',
      name: '退出',
      component: unbind
    },
    {
      path: '/chpass',
      name: '修改密码',
      component: chpass
    },
    {
      path: '/chmobile',
      name: '修改手机号',
      component: chmobile
    },
    {
      path: '/dzybk',
      name: '电子医保卡',
      component: dzybk
    },
    {
      path: '/passkbd',
      name: '密码键盘',
      component: passkbd
    },
    {
      path: '/orderlist',
      name: '待支付列表',
      component: orderlist
    },
    {
      path: '/payorderlist',
      name: '已支付订单列表',
      component: payorderlist
    },
    {
      path: '/orderdetail',
      name: '订单详情',
      component: orderdetail
    },
    {
      path: '/navjzlist',
      name: '导诊单',
      component: navjzlist
    },
    {
      path: '/myOrder/:akb020',
      name: '我的订单',
      component: myOrder
    },
    {
      path: '/resetPass',
      name: '重置密码',
      component: resetPass
    },
    {
      path: '/ddyyAndYd',
      name: '定点医院药店',
      component: ddyyAndYd,
      children: [
        {name: '定点医院', path: 'ddjgcx', component: ddjgcx},
        {name: '定点药店', path: 'ddydcx', component: ddydcx}
      ]
    },
    {
      path: '/grzhTotal',
      name: '个人账户查询',
      component: grzhTotal,
      children: [
        {name: '账户余额', path: 'grzhcx', component: grzhcx},
        {name: '缴费信息', path: 'jfxxcx', component: jfxxcx},
        {name: '收支明细', path: 'grszmxcx', component: grszmxcx}
      ]
    },
    {
      path: '/refresh',
      name: '刷新页',
      component: refresh
    },
    {
      path: '/gjtpybaNav',
      name: '国家谈判药/高值药审核',
      component: gjtpybaNav
    },
    {
      path: '/gjtpybaSb',
      name: '国家谈判药/高值药审核申报',
      component: gjtpybaSb
    },
    {
      path: '/gjtpybaCx',
      name: '国家谈判药/高值药审核查询',
      component: gjtpybaCx
    },
    {
      path: '/gjtpybaXz',
      name: '审核申报须知',
      component: gjtpybaXz
    },
    {
      path: '/sysmfw',
      name: '送药上门服务',
      component: sysmfwNav
    },
    {
      path: '/sysmfwXz',
      name: '送药上门服务须知',
      component: sysmfwXz
    },
    {
      path: '/sysmfwPj',
      name: '送药上门服务评价',
      component: sysmfwPj
    },
    {
      path: '/yyckbx',
      name: '预约窗口报销',
      component: yyckbx_nav
    },
    {
      path: '/yyckbxxz',
      name: '预约窗口报销须知',
      component: yyckbx_xz
    },
    {
      path: '/ydjycqbaNav',
      name: '异地就医长期备案',
      component: ydjycqbaNav
    },
    {
      path: '/ydjycqbaSb',
      name: '异地就医长期备案申报',
      component: ydjycqbaSb
    },
    {
      path: '/ydjycqbaCx',
      name: '异地就医长期备案查询',
      component: ydjycqbaCx
    },
    {
      path: '/ydjycqbasbCx',
      name: '异地就医长期备案申报撤销',
      component: ydjycqbasbCx
    },
    {
      path: '/ydjycqbaXz',
      name: '异地就医长期备案申报须知',
      component: ydjycqbaXz
    },

    {
      path: '/ydba_nav_flow1',
      name: '异地就医临时备案申请',
      component: ydba_nav_flow1
    },
    {
      path: '/ydba_nav_flow2',
      name: '异地就医长期备案申请',
      component: ydba_nav_flow2
    },
    {
      path: '/ydba_nav_flow3',
      name: '急诊抢救就医备案申请',
      component: ydba_nav_flow3
    },
    {
      path: '/ydba_nav_mz',
      name: '异地门诊备案申请',
      component: ydba_nav_mz
    },
    {
      path: '/lsbacx',
      name: '临时备案申请查询',
      component: lsbacx
    },
    {
      path: '/gyryEdit',
      name: '家庭成员信息变更',
      component: gyryEdit
    },
    {
      path: '/mxbsq',
      name: '慢性病申请',
      component: mxbsq
    },
    {
      path: '/tsbsq',
      name: '特殊病申请',
      component: tsbsq
    },
    {
      path: '/txbtsbbaCx',
      name: '慢性病特殊病申报查询',
      component: txbtsbbaCx
    },
    {
      path: '/mbtbba',
      name: '慢性病特殊病备案',
      component: mbtbba
    }
  ]
})
let notNeedLogin = ['/',
  '/first',
  '/query',
  '/ywbl',
  '/my',
  '/login',
  '/register',
  '/gjtpyp',
  '/gzypxxcx',
  '/gjtpypddcx',
  '/ddjgcx',
  '/ddydcx',
  '/ybml',
  '/ddyyAndYd',
  '/resetPass',
  '/gjtpybaNav',
  '/sysmfw',
  '/sysmfwXz',
  '/ydjycqbaNav',
  '/ydba_nav_mz',
  '/ydjycqbasbCx'
]
router.beforeEach((to, from, next) => {
  if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
    window.entryUrl = location.href.split('#')[0]
  }
  /* if (to.path === '/kxcwx/') {
    if (to.query.code) {
      localStorage.setItem('weCode', to.query.code)
    }
    var url = location.href // 获取url中"?"符后的字串
    if (url.indexOf('?goto') !== -1) {
      var str = url.split('?')[1]
      alert('调试信息str--' + str)
      var arr = str.split('&')
      var theRequest = {}
      for (var i = 0; i < arr.length; i++) {
        theRequest[arr[i].split('=')[0]] = arr[i].split('=')[1]
      }
      alert('调试信息goto--' + theRequest['goto'] + 'akb020---' + theRequest['akb020'])
      if (theRequest['goto'] && theRequest['goto'] === 'myOrder') {
        alert('jjjjj')
        next({path: '/myOrder/' + theRequest['akb020']})
      }
    }
  } */
  /* let aac001 = this.$root.aac001
  if (!aac001 && to.path !== '/login') {
    next({path: '/login'})
  } else {
    next()
  } */
  if (to.query.code) {
    localStorage.setItem('weCode', to.query.code)
  }
  if (to.path === '/kxcwx/') {
    var url = location.href // 获取url中"?"符后的字串
    if (url.indexOf('?goto') !== -1) {
      var str = url.split('?')[1]
      var arr = str.split('&')
      var theRequest = {}
      for (var i = 0; i < arr.length; i++) {
        theRequest[arr[i].split('=')[0]] = arr[i].split('=')[1]
      }
      if (theRequest['goto'] && theRequest['goto'] === 'myOrder') {
        // alert('jjjjj')
        next({path: '/myOrder/' + theRequest['akb020']})
      }
    } else {
      if (to.matched.length === 0) {
        // alert('未匹配路由1')
        from.name ? next({ name: from.name }) : next('/')
      } else {
        next()
      }
    }
  } else {
    if (to.matched.length === 0) {
      // alert('未匹配路由2')
      from.name ? next({ name: from.name }) : next('/')
    } else {
      // 根据路由判断是否需要登录
      if (notNeedLogin.indexOf(to.path) === -1 && !localStorage.getItem('aac001')) {
        Toast('请先登录后再进行操作!')
        next({path: '/login'})
      } else {
        next()
      }
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js